import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="Footer">
            <p>Vempix © 2025 - Todos os direitos reservados</p>
        </footer>
    );
}

export default Footer;
